import type {WafTokenState} from './wafToken';

// Temporary: lets the backend check whether tokenless requests come from this
// app, and in what WAF state they were sent.
export const WAF_DEBUG_HEADER = 'x-tw-waf-debug';

// Checks the cookie as well as getToken
export function hasWafToken(state: WafTokenState) {
  return state.tokenRequest === 'ok' && state.hasTokenCookie;
}

const flag = (value: boolean | undefined) =>
  value === undefined ? '' : Number(value);

export function formatWafDebugHeader(state: WafTokenState) {
  return [
    `sdk=${flag(state.sdkLoaded)}`,
    `script=${state.scriptStatus}`,
    `getToken=${state.tokenRequest}`,
    `hasToken=${flag(state.sdkHasToken)}`,
    `cookie=${flag(state.hasTokenCookie)}`,
    `t=${state.pageAgeMs}`,
  ].join(';');
}
